import React, { useState } from 'react';
import OwnerInvoicingSubTab from './OwnerInvoicingSubTab';


const OwnerInvoicingTab = () => {
  const [activeTab, setActiveTab] = useState('personalInvoices');

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="customer-details-tab">
      <div className={`tab ${activeTab === 'personalInvoices' ? 'active' : ''}`} onClick={() => handleTabClick('personalInvoices')}>
        Personal Invoices
      </div>
      <div className={`tab ${activeTab === 'commercialInvoices' ? 'active' : ''}`} onClick={() => handleTabClick('commercialInvoices')}>
        Commercial Invoices
      </div>
      
    <div className='order-details-tab-divider'></div>
      <div className="tab-content">
        {activeTab === 'personalInvoices' && (
        <div className="details-content">
           <section>
                <OwnerInvoicingSubTab />
            </section>
            
        </div>
          
        )}

        {activeTab === 'commercialInvoices' && (
          <div className="activity-content">
            <section>
            <OwnerInvoicingSubTab />
            </section>
            

          </div>
        )}
       

      </div>
    </div>
  );
};

export default OwnerInvoicingTab;
